import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INews } from '../interfaces/news';
import authHeader from '../helpers/auth-header';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  newsSet: INews[] = [];
  firstNewsItem: INews | any;
  secondNewsItem: INews | any;
  
  constructor(private http: HttpClient) { }

  getNews() {
    const config = {
      headers: {
           'Content-Type': 'application/json;charset=UTF-8',
           'Authorization': authHeader()
      }
  };  
    const url = `${environment.APP_API_URL}/api/v1/Lists/News`;
      return this.http.get(url, config)
        .pipe(
          map((response: any) =>{
            const result = (response as any);
            this.newsSet = result.map((a:any) => {a.body = a.body.replace(/&nbsp;/g,' '); return a});
            if (this.newsSet.length > 0) {
                this.firstNewsItem = this.newsSet[0];
            }
            if (this.newsSet.length > 1) {
                this.secondNewsItem = this.newsSet[1];
            }
            return ['true'];
       }),
       catchError((error : string) => {
            console.error(error);
            return ['false'];
       })
      );
  }

  getNewsForPreview(itemId: string, parentId: string) {
    const url = `${environment.APP_API_URL}/api/v1/Lists/News/Preview?itemId={itemId}&parentId={parentId}`
          .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
          .replace(`{${"parentId"}}`, encodeURIComponent(String(parentId)));
    return this.http.get(url)
         .pipe(
              map((response: any) =>{
                   const result = (response as any);
                   console.log(response)
                   this.newsSet = result.map((a:any) => {a.body = a.body.replace(/&nbsp;/g,' '); return a});
                   if (this.newsSet.length > 1) {
                       this.firstNewsItem = this.newsSet[0];
                       this.secondNewsItem = this.newsSet[1];
                   }
                   return ['true'];
              }),
              catchError((error : string) => {
                   console.error(error);
                   return ['false'];
              })
         );
  }
}
